<template>
  <div>
    <h1 v-if="!isEditing">
      Configure {{ definition.name }} Widget
    </h1>
    <el-form
      ref="form"
      :model="form"
      label-position="top"
      size="small"
    >
      <el-row :gutter="12">
        <el-col
          v-for="field in definition.fields"
          :key="field.key"
          :span="field.span || 24"
        >
          <el-form-item :label="field.label">
            <el-input-number
              v-if="field.type === 'number'"
              v-model="form[field.key]"
              class="w-100"
              controls-position="right"
            />
            <el-select
              v-else-if="field.type === 'select'"
              v-model="form[field.key]"
              class="w-100"
            >
              <el-option
                v-for="option in field.options"
                :key="option.value || option"
                :label="option.label || option"
                :value="option.value || option"
              />
            </el-select>
            <el-switch
              v-else-if="field.type === 'boolean'"
              v-model="form[field.key]"
            />
            <el-input
              v-else
              v-model="form[field.key]"
              :type="field.type === 'textarea' ? 'textarea' : 'text'"
              :rows="field.rows || 3"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <template v-if="definition.itemFields">
        <div class="static-widget-configure__heading">
          <strong>Rows</strong>
          <el-button
            type="text"
            size="mini"
            @click="addItem"
          >
            <FontAwesomeIcon :icon="['fal', 'plus']" />
            Add Row
          </el-button>
        </div>
        <div
          v-for="(item, index) in form.items"
          :key="index"
          class="static-widget-configure__item"
        >
          <el-row :gutter="8">
            <el-col
              v-for="field in definition.itemFields"
              :key="field.key"
              :span="field.span || 12"
            >
              <el-form-item :label="field.label">
                <el-input-number
                  v-if="field.type === 'number'"
                  v-model="item[field.key]"
                  class="w-100"
                  controls-position="right"
                />
                <el-select
                  v-else-if="field.type === 'select'"
                  v-model="item[field.key]"
                  class="w-100"
                >
                  <el-option
                    v-for="option in field.options"
                    :key="option.value || option"
                    :label="option.label || option"
                    :value="option.value || option"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="item[field.key]"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-button
            class="static-widget-configure__remove"
            type="text"
            title="Remove row"
            @click="removeItem(index)"
          >
            <FontAwesomeIcon :icon="['fal', 'trash']" />
          </el-button>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
function clone (value) {
  return JSON.parse(JSON.stringify(value))
}

export default {
  props: {
    definition: {
      type: Object,
      required: true
    },
    widget: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: this.initialForm()
    }
  },
  computed: {
    isEditing () {
      return Object.keys(this.widget).length > 0
    }
  },
  methods: {
    initialForm () {
      const defaults = this.definition.fields.reduce((form, field) => {
        form[field.key] = clone(field.default)
        return form
      }, {})

      if (this.definition.itemFields) {
        defaults.items = clone(this.definition.defaultItems || [])
      }

      if (!Object.keys(this.widget).length) return defaults

      const identifier = Object.keys(this.widget)[0]
      return Object.assign(defaults, clone(this.widget[identifier].configuration))
    },
    addItem () {
      const item = this.definition.itemFields.reduce((row, field) => {
        row[field.key] = clone(field.default)
        return row
      }, {})
      this.form.items.push(item)
    },
    removeItem (index) {
      this.form.items.splice(index, 1)
    },
    submit () {
      const formattedWidget = {
        name: this.definition.name,
        configuration: Object.assign({}, clone(this.form), {
          minW: this.definition.minW,
          minH: this.definition.minH,
          isResizable: true
        })
      }

      if (!this.isEditing) {
        this.$emit('submitted', formattedWidget)
        return
      }

      const identifier = Object.keys(this.widget)[0]
      this.$emit('submitted', {
        [identifier]: Object.assign({}, this.widget[identifier], formattedWidget)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.static-widget-configure__heading {
  align-items: center;
  border-bottom: 1px solid #ebeef2;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.static-widget-configure__item {
  background: #f7f8fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 10px 42px 0 10px;
  position: relative;
}

.static-widget-configure__remove {
  color: #c44747;
  position: absolute;
  right: 12px;
  top: 8px;
}
</style>
